import { useRef, useState } from "react";
import { Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorText, mediaUrl } from "../lib/api";

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const UploadButton = ({ onUploaded, accept = "image/jpeg,image/png,image/webp", multiple = false, label = "Upload image", testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) onUploaded(await uploadFile(f), f);
      toast.success(files.length > 1 ? `${files.length} files uploaded` : "Uploaded");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
      ref.current.value = "";
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept={accept} multiple={multiple} onChange={pick} className="hidden" />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid} className="inline-flex items-center gap-2 border border-wine px-3 py-2 text-xs uppercase tracking-[0.12em] text-wine hover:bg-wine hover:text-ivory disabled:opacity-60">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {busy ? "Uploading…" : label}
      </button>
    </>
  );
};

export const ImageField = ({ label, value, onChange, testid }) => (
  <div>
    <p className="mb-2 text-xs font-medium uppercase tracking-[0.12em] text-charcoal/80">{label}</p>
    <div className="flex items-center gap-4">
      <div className="h-24 w-20 shrink-0 overflow-hidden border border-line bg-sand">
        {value && <img src={mediaUrl(value)} alt="" className="h-full w-full object-cover" />}
      </div>
      <div className="flex flex-col items-start gap-2">
        <UploadButton onUploaded={(u) => onChange(u)} label={value ? "Replace" : "Upload image"} testid={testid} />
        {value && (
          <button type="button" onClick={() => onChange("")} className="flex items-center gap-1 text-xs text-muted-ink hover:text-wine"><X size={12} /> Remove</button>
        )}
      </div>
    </div>
  </div>
);
